import hualienMeta from 'meta/hualien.json';
import jiaoxiMeta from 'meta/jiaoxi.json';
import kaohsiungMeta from 'meta/kaohsiung.json';
import kaohsiungStationMeta from 'meta/kaohsiungStation.json';
import mainMeta from 'meta/main.json';
import NTUMeta from 'meta/NTU.json';
import sanchongMeta from 'meta/sanchong.json';
import ximendingMeta from 'meta/ximending.json';
import hushanMeta from 'meta/hushan.json';
import zhongshanMeta from 'meta/zhongshan.json';
// import osakaShinsaibashiMeta from 'meta/osaka-shinsaibashi.json';

import ximenGrayLarge from 'images/home/img_ximen_grey.jpg';
import ximenColorLarge from 'images/home/img_ximen_color.jpg';
import ximenThumbnail from 'images/home/thumbnail/img_ximen_grey@2x.jpg';
import ntuGrayLarge from 'images/home/img_ntu_grey.jpg';
import ntuColorLarge from 'images/home/img_ntu_color.jpg';
import ntuThumbnail from 'images/home/thumbnail/img_ntu_grey@2x.jpg';
import kaohsiungGrayLarge from 'images/home/img_kao_grey.jpg';
import kaohsiungColorLarge from 'images/home/img_kao_color.jpg';
import kaohsiungThumbnail from 'images/home/thumbnail/img_kao_grey@2x.jpg';
import kaohsiungStationGrayLarge from 'images/home/img_kaostation_grey.jpg';
import kaohsiungStationColorLarge from 'images/home/img_kaostation_color.jpg';
import kaohsiungStationThumbnail from 'images/home/thumbnail/img_kaostation_grey@2x.jpg';
import hualienGrayLarge from 'images/home/img_hualien_grey.jpg';
import hualienColorLarge from 'images/home/img_hualien_color.jpg';
import hualienThumbnail from 'images/home/thumbnail/img_hualien_grey@2x.jpg';
import jiaoxiGrayLarge from 'images/home/img_jiaoxi_grey.jpg';
import jiaoxiColorLarge from 'images/home/img_jiaoxi_color.jpg';
import jiaoxThumbnail from 'images/home/thumbnail/img_jiaoxi_grey@2x.jpg';

import ximenGraySmall from 'images/home/img_ximen_grey@2x.jpg';
import ximenColorSmall from 'images/home/img_ximen_color@2x.jpg';
import ntuGraySmall from 'images/home/img_ntu_grey@2x.jpg';
import ntuColorSmall from 'images/home/img_ntu_color@2x.jpg';
import kaohsiungGraySmall from 'images/home/img_kao_grey@2x.jpg';
import kaohsiungColorSmall from 'images/home/img_kao_color@2x.jpg';
import kaohsiungStationGraySmall from 'images/home/img_kaostation_grey@2x.jpg';
import kaohsiungStationColorSmall from 'images/home/img_kaostation_color@2x.jpg';
import hualienGraySmall from 'images/home/img_hualien_grey@2x.jpg';
import hualienColorSmall from 'images/home/img_hualien_color@2x.jpg';
import jiaoxiGraySmall from 'images/home/img_jiaoxi_grey@2x.jpg';
import jiaoxiColorSmall from 'images/home/img_jiaoxi_color@2x.jpg';

import sanchongColorLarge from 'images/home/img_sanchong_color.jpg';
import sanchongColorSmall from 'images/home/img_sanchong_color@2x.jpg';
import sanchongGrayLarge from 'images/home/img_sanchong_grey.jpg';
import sanchongGraySmall from 'images/home/img_sanchong_grey@2x.jpg';
import sanchongThumbnail from 'images/home/thumbnail/img_sanchong_grey@2x.jpg';

import hushanColorLarge from 'images/home/img_hushan_color.jpg';
import hushanColorSmall from 'images/home/img_hushan_color@2x.jpg';
import hushanGrayLarge from 'images/home/img_hushan_grey.jpg';
import hushanGraySmall from 'images/home/img_hushan_grey@2x.jpg';
import hushanThumbnail from 'images/home/thumbnail/img_hushan_grey@2x.jpg';

import osakaShinsaibashiColorLarge from 'images/home/img_osakaShinsaibashi_color.jpg';
import osakaShinsaibashiColorSmall from 'images/home/img_osakaShinsaibashi_color@2x.jpg';
import osakaShinsaibashiGrayLarge from 'images/home/img_osakaShinsaibashi_grey.jpg';
import osakaShinsaibashiGraySmall from 'images/home/img_osakaShinsaibashi_grey@2x.jpg';
import osakaShinsaibashiThumbnail from 'images/home/thumbnail/img_osakaShinsaibashi_grey@2x.jpg';

import zhongshanColorLarge from 'images/home/img_zhongshan_color.jpg';
import zhongshanColorSmall from 'images/home/img_zhongshan_color@2x.jpg';
import zhongshanGrayLarge from 'images/home/img_zhongshan_grey.jpg';
import zhongshanGraySmall from 'images/home/img_zhongshan_grey@2x.jpg';
import zhongshanThumbnail from 'images/home/thumbnail/img_zhongshan_grey@2x.jpg';

import { responsiveImage } from 'util/responsiveImage';

const ximen = {
	gray: responsiveImage(ximenGrayLarge, ximenGraySmall),
	color: responsiveImage(ximenColorLarge, ximenColorSmall),
	thumbnail: ximenThumbnail,
};

const ntu = {
	gray: responsiveImage(ntuGrayLarge, ntuGraySmall),
	color: responsiveImage(ntuColorLarge, ntuColorSmall),
	thumbnail: ntuThumbnail,
};

const zhongshan = {
	gray: responsiveImage(zhongshanGrayLarge, zhongshanGraySmall),
	color: responsiveImage(zhongshanColorLarge, zhongshanColorSmall),
	thumbnail: zhongshanThumbnail,
};

const kaohsiung = {
	gray: responsiveImage(kaohsiungGrayLarge, kaohsiungGraySmall),
	color: responsiveImage(kaohsiungColorLarge, kaohsiungColorSmall),
	thumbnail: kaohsiungThumbnail,
};

const kaohsiungStation = {
	gray: responsiveImage(kaohsiungStationGrayLarge, kaohsiungStationGraySmall),
	color: responsiveImage(kaohsiungStationColorLarge, kaohsiungStationColorSmall),
	thumbnail: kaohsiungStationThumbnail,
};

const hualien = {
	gray: responsiveImage(hualienGrayLarge, hualienGraySmall),
	color: responsiveImage(hualienColorLarge, hualienColorSmall),
	thumbnail: hualienThumbnail,
};

const jiaoxi = {
	gray: responsiveImage(jiaoxiGrayLarge, jiaoxiGraySmall),
	color: responsiveImage(jiaoxiColorLarge, jiaoxiColorSmall),
	thumbnail: jiaoxThumbnail,
};

const sanchong = {
	gray: responsiveImage(sanchongGrayLarge, sanchongGraySmall),
	color: responsiveImage(sanchongColorLarge, sanchongColorSmall),
	thumbnail: sanchongThumbnail,
};

const hushan = {
	gray: responsiveImage(hushanGrayLarge, hushanGraySmall),
	color: responsiveImage(hushanColorLarge, hushanColorSmall),
	thumbnail: hushanThumbnail,
};

const osakaShinsaibashi = {
	gray: responsiveImage(osakaShinsaibashiGrayLarge, osakaShinsaibashiGraySmall),
	color: responsiveImage(osakaShinsaibashiColorLarge, osakaShinsaibashiColorSmall),
	thumbnail: osakaShinsaibashiThumbnail,
};

export const defaultHotelList = [
	'main',
	'ximending',
	'NTU',
	'zhongshan',
	'kaohsiung',
	'kaohsiungStation',
	'hualien',
	'jiaoxi',
	'sanchong',
	'hushan',
	'osakaShinsaibashi',
];

const officialLinks = {
	// line: 'https://page.line.me/justsleep?openQrModal=true',
	// tripAdvisor: '',
	fb: 'https://www.facebook.com/JustSleepJS',
	ig: 'https://www.instagram.com/justsleep_js/',
	weibo: 'http://weibo.com/u/3030763041',
	youtube: 'https://www.youtube.com/user/JustSleepChannel?feature=watch'
}

// export const hotelWithEvent = ['kaohsiung', 'kaohsiungStation', 'hualien'];

export const fakeHotel = {
	id: -99,
	key: 'fake',
	bookingCode: '',
	foreignBookingCode: '',
	name: 'name',
	enName: 'FAKE',
	intro: 'intro',
	address: 'address',
	tel: '+886 2-7735-5000000',
	mainImage: jiaoxi.color,
	grayImage: jiaoxi.gray,
	colorImage: jiaoxi.color,
	thumbnail: jiaoxi.thumbnail,
	location: {
		lat: 24.830266,
		lng: 121.773063,
	},
	socialLinks: {
		line: '',
		tripAdvisor: '',
	},
};

export const hotelData = t => ({
	main: {
		id: -1,
		key: 'main',
		bookingCode: '',
		foreignBookingCode: '',
		hotelHomeTitle: t('hotelMain')('title'),
		name: t('hotelMain')('name'),
		enName: 'MAIN',
		intro: t('hotelMain')('intro'),
		intro2: t('hotelMain')('intro2'),
		address: t('hotelMain')('address'),
		tel: '+886 2 7735 5088',
		// contactUs: t('hotelMain')('contactUs'),
		// mainImage: ximen.color,
		// grayImage: ximen.gray,
		// colorImage: ximen.color,
		location: { lat: 25.045244, lng: 121.509994 },
		mapLink: 'https://goo.gl/maps/PL61XqLFvQP2',
		socialLinks: {
			line: ' https://lin.ee/6pifgqN',
			tripAdvisor: '',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: mainMeta,
		registrationNumber: '',
	},
	ximending: {
		id: 0,
		key: 'ximending',
		bookingCode: 'JSXMD',
		foreignBookingCode: '25352',
		hotelHomeTitle: t('hotelXimen')('title'),
		name: t('hotelXimen')('name'),
		enName: 'XIMENDING',
		intro: t('hotelXimen')('intro'),
		address: t('hotelXimen')('address'),
		tel: '+886 2 2370 9000',
		contactUs: t('hotelXimen')('contactUs'),
		mainImage: ximen.color,
		grayImage: ximen.gray,
		colorImage: ximen.color,
		thumbnail: ximen.thumbnail,
		location: { lat: 25.045244, lng: 121.509994 },
		mapLink: 'https://goo.gl/maps/yQmoZsgvJZL2',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13808853',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: ximendingMeta,
		registrationNumber: 348,
	},
	NTU: {
		id: 2,
		key: 'NTU',
		bookingCode: 'JSNTU',
		foreignBookingCode: '59416',
		hotelHomeTitle: t('hotelNTU')('title'),
		name: t('hotelNTU')('name'),
		enName: 'NTU',
		intro: t('hotelNTU')('intro'),
		address: t('hotelNTU')('address'),
		tel: '+886 2 7735 5088',
		contactUs: t('hotelNTU')('contactUs'),
		mainImage: ntu.color,
		grayImage: ntu.gray,
		colorImage: ntu.color,
		thumbnail: ntu.thumbnail,
		location: { lat: 25.013504, lng: 121.536306 },
		mapLink: 'https://goo.gl/maps/PL61XqLFvQP2',
		socialLinks: {
			line: ' https://lin.ee/6pifgqN',
			tripAdvisor:
				'http://www.tripadvisor.com.tw/Hotel_Review-g293913-d4023325-Reviews-Just_Sleep_NTU-Taipei.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: NTUMeta,
		registrationNumber: 802,
	},
	zhongshan: {
		id: 0,
		key: 'zhongshan',
		bookingCode: 'JSZS',
		foreignBookingCode: '',
		hotelHomeTitle: t('hotelZhongshan')('title'),
		name: t('hotelZhongshan')('name'),
		enName: 'Taipei Zhongshan',
		intro: t('hotelZhongshan')('intro'),
		address: t('hotelZhongshan')('address'),
		contactUs: t('hotelZhongshan')('contactUs'),
		tel: '+886 2 7725 0088',
		mainImage: zhongshan.color,
		grayImage: zhongshan.gray,
		colorImage: zhongshan.color,
		thumbnail: zhongshan.thumbnail,
		location: { lat: 25.051311, lng: 121.5248328 },
		mapLink: 'https://maps.app.goo.gl/8qcga6Em5jeLpQRu8',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor: 'https://lihi1.me/29JeZ',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: zhongshanMeta,
		registrationNumber: '819-1',
	},
	kaohsiung: {
		id: 3,
		key: 'kaohsiung',
		bookingCode: 'JSKZZ',
		foreignBookingCode: '60289',
		hotelHomeTitle: t('hotelKaohsiung')('title'),
		name: t('hotelKaohsiung')('name'),
		enName: 'KAOHSIUNG',
		intro: t('hotelKaohsiung')('intro'),
		address: t('hotelKaohsiung')('address'),
		tel: '+886 7 972 3568',
		contactUs: t('hotelKaohsiung')('contactUs'),
		mainImage: kaohsiung.color,
		grayImage: kaohsiung.gray,
		colorImage: kaohsiung.color,
		thumbnail: kaohsiung.thumbnail,
		location: { lat: 22.628662, lng: 120.331923 },
		mapLink: 'https://goo.gl/maps/E1iP9mBy5fv',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor:
				'http://www.tripadvisor.com.tw/Hotel_Review-g297908-d5288137-Reviews-Just_Sleep_Kaohsiung_Zhongzheng-Kaohsiung.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: kaohsiungMeta,
		registrationNumber: 450,
	},
	kaohsiungStation: {
		id: 4,
		key: 'kaohsiungStation',
		bookingCode: 'JSKKS',
		foreignBookingCode: '66462',
		hotelHomeTitle: t('hotelKaohsiungStation')('title'),
		name: t('hotelKaohsiungStation')('name'),
		enName: 'KAOHSIUNG STATION',
		intro: t('hotelKaohsiungStation')('intro'),
		address: t('hotelKaohsiungStation')('address'),
		tel: '+886 7 973 3588',
		contactUs: t('hotelKaohsiungStation')('contactUs'),
		mainImage: kaohsiungStation.color,
		grayImage: kaohsiungStation.gray,
		colorImage: kaohsiungStation.color,
		thumbnail: kaohsiungStation.thumbnail,
		location: { lat: 22.635753, lng: 120.302508 },
		mapLink: 'https://goo.gl/maps/NzVcBZBpaMq',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor:
				'https://www.tripadvisor.com.tw/Hotel_Review-g13808513-d8598482-Reviews-Just_Sleep_Kaohsiung_Station-Xinxing_Kaohsiung.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: kaohsiungStationMeta,
		registrationNumber: 481,
	},
	hualien: {
		id: 5,
		key: 'hualien',
		bookingCode: 'JSHZZ',
		foreignBookingCode: '60288',
		hotelHomeTitle: t('hotelHualien')('title'),
		name: t('hotelHualien')('name'),
		enName: 'HUALIEN',
		intro: t('hotelHualien')('intro'),
		address: t('hotelHualien')('address'),
		tel: '+886 3 890 0069',
		contactUs: t('hotelHualien')('contactUs'),
		mainImage: hualien.color,
		grayImage: hualien.gray,
		colorImage: hualien.color,
		thumbnail: hualien.thumbnail,
		location: { lat: 23.975141, lng: 121.603726 },
		mapLink: 'https://goo.gl/maps/4vTW7LeeyLS2',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor:
				'http://www.tripadvisor.com.tw/Hotel_Review-g297907-d5288138-Reviews-Just_Sleep_Hualien_Zhongzheng-Hualien.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: hualienMeta,
		registrationNumber: 141,
	},
	jiaoxi: {
		id: 6,
		key: 'jiaoxi',
		bookingCode: 'JSJX',
		foreignBookingCode: '64173',
		hotelHomeTitle: t('hotelJiaoxi')('title'),
		name: t('hotelJiaoxi')('name'),
		enName: 'JIAOXI',
		intro: t('hotelJiaoxi')('intro'),
		address: t('hotelJiaoxi')('address'),
		tel: '+886 3 910 2000',
		contactUs: t('hotelJiaoxi')('contactUs'),
		mainImage: jiaoxi.color,
		grayImage: jiaoxi.gray,
		colorImage: jiaoxi.color,
		thumbnail: jiaoxi.thumbnail,
		location: { lat: 24.828856, lng: 121.772483 },
		mapLink: 'https://goo.gl/maps/SHhPLEGy1Zn',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor:
				'https://www.tripadvisor.com.tw/Hotel_Review-g13806648-d7230669-Reviews-Just_Sleep_Jiao_Xi_Hotel-Jiaoxi_Yilan.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: jiaoxiMeta,
		registrationNumber: 220,
	},
	sanchong: {
		id: 7,
		key: 'sanchong',
		bookingCode: 'JSSC',
		foreignBookingCode: '',
		hotelHomeTitle: t('hotelSanchong')('title'),
		name: t('hotelSanchong')('name'),
		enName: 'SANCHONG',
		intro: t('hotelSanchong')('intro'),
		address: t('hotelSanchong')('address'),
		tel: '+886 2 2280 6111',
		contactUs: t('hotelSanchong')('contactUs'),
		mainImage: sanchong.color,
		grayImage: sanchong.gray,
		colorImage: sanchong.color,
		thumbnail: sanchong.thumbnail,
		location: { lat: 25.077427, lng: 121.487482 },
		mapLink:
			'https://www.google.com.tw/maps/place/%E6%8D%B7%E7%B5%B2%E6%97%85%E5%8F%B0%E5%8C%97%E4%B8%89%E9%87%8D%E9%A4%A8/@25.077349,121.4869415,19z/data=!3m1!4b1!4m13!1m7!3m6!1s0x3442a8d76c3e5a67:0xce925ec0fbc71bc2!2zMjQx5paw5YyX5biC5LiJ6YeN5Y2A5LiJ5ZKM6Lev5Zub5q61MTA3LTHomZ8!3b1!8m2!3d25.077349!4d121.48749!3m4!1s0x3442a95aa166790d:0xca70944b2cf7a152!8m2!3d25.077349!4d121.48749?hl=zh-TW&authuser=0',
		socialLinks: {
			line: 'https://lin.ee/6pifgqN',
			tripAdvisor: 'https://www.tripadvisor.com.tw/Hotel_Review-g13808853',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: sanchongMeta,
		registrationNumber: '316-1',
	},
	'hushan': {
		id: 8,
		key: 'hushan',
		bookingCode: 'JSTD',
		foreignBookingCode: '',
		hotelHomeTitle: t('hotelHushan')('title'),
		name: t('hotelHushan')('name'),
		enName: 'TAINAN HUSHAN',
		intro: t('hotelHushan')('intro'),
		address: t('hotelHushan')('address'),
		tel: '+886 6 266 0568',
		contactUs: t('hotelHushan')('contactUs'),
		mainImage: hushan.color,
		grayImage: hushan.gray,
		colorImage: hushan.color,
		thumbnail: hushan.thumbnail,
		location: { lat: 22.939149, lng: 120.2267631 },
		mapLink: 'https://goo.gl/maps/A4VEnaFmEgcMD9g36',
		socialLinks: {
			line: 'https://page.line.me/justsleep?openQrModal=true',
			tripAdvisor:
				'https://www.tripadvisor.com/Hotel_Review-g13806829-d23385372-Reviews-Just_Sleep_Tainan_Ten_Drum_Silks_Hotel_Group-Rende_Tainan.html',
			fb: officialLinks.fb,
			ig: officialLinks.ig,
			weibo: officialLinks.weibo,
			youtube: officialLinks.youtube,
		},
		meta: hushanMeta,
		registrationNumber: 347,
	},
	osakaShinsaibashi: {
		id: 9,
		key: 'osakaShinsaibashi',
		bookingCode: 'JSOS',
		foreignBookingCode: '',
		hotelHomeTitle: t('hotelOsakaShinsaibashi')('title'),
		name: t('hotelOsakaShinsaibashi')('name'),
		enName: 'Osaka Shinsaibashi',
		intro: t('hotelOsakaShinsaibashi')('intro'),
		address: t('hotelOsakaShinsaibashi')('address'),
		tel: t('hotelOsakaShinsaibashi')('tel'),
		contactUs: t('hotelOsakaShinsaibashi')('contactUs'),
		fax: t('hotelOsakaShinsaibashi')('fax'),
		mainImage: osakaShinsaibashi.color,
		grayImage: osakaShinsaibashi.gray,
		colorImage: osakaShinsaibashi.color,
		thumbnail: osakaShinsaibashi.thumbnail,
		// location: { lat: 25.077427, lng: 121.487482 },
		// mapLink: 'https://goo.gl/maps/A4VEnaFmEgcMD9g36', //footer地址的連結
		socialLinks: {
			ig: 'https://www.instagram.com/justsleep_os',
			fb: 'https://www.facebook.com/profile.php?id=100089151938255',
		},
		// meta: osakaShinsaibashiMeta,
		// registrationNumber: 347,
	},
});

const fakeTranslation = () => key => key;
export const defaultHotelData = hotelData(fakeTranslation);

export const defaultHotelMeta = {
	id: 1,
	title: '官網訂房最低價，另享高鐵訂票75折優惠',
	description:
		'鄰近西門町商圈、捷運西門站、西門町商圈，全新時尚大方空間設計，是旅人最佳選擇。捷絲旅台北西門館官網訂房最低價，並享高鐵訂票75折優惠！',
	keywords:
		'捷絲旅台北西門館, 西門町, 西門町飯店, 西門町住宿, 西門住宿推薦, 捷運西門站, 台北車站, 台北車站住宿, 西門町商圈, 台北旅遊, 台北旅行, 台北景點, 台北美食, 台北自由行',
};

export const hotelAttractionMock = {
	ximending: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=ximending',
			shop: { id: 1, title: '台北西門' },
			title: '西門町',
		},
	],
	NTU: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=NTU',
			shop: { id: 1, title: 'NTU' },
			title: 'NTU',
		},
	],
	zhongshan: [
		{
			address: '"臺北市中山區中山北路一段135巷39號',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: '',
			shop: { id: 1, title: '台北中山' },
			title: '台北中山',
		},
	],
	kaohsiung: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=kaohsiung',
			shop: { id: 1, title: 'kaohsiung' },
			title: 'kaohsiung',
		},
	],
	kaohsiungStation: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=kaohsiungStation',
			shop: { id: 1, title: 'kaohsiungStation' },
			title: 'kaohsiungStation',
		},
	],
	hualien: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=hualien',
			shop: { id: 1, title: 'hualien' },
			title: 'hualien',
		},
	],
	jiaoxi: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=jiaoxi',
			shop: { id: 1, title: 'jiaoxi' },
			title: 'jiaoxi',
		},
	],
	sanchong: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=sanchong',
			shop: { id: 1, title: 'sanchong' },
			title: 'sanchong',
		},
	],
	hushan: [
		{
			address: '臺北市萬華區中華路一段',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=hushan',
			shop: { id: 1, title: 'hushan' },
			title: 'hushan',
		},
	],
	osakaShinsaibashi: [
		{
			address: '542-0081大阪市中央區南船場二丁目9-15',
			category: { id: 1, name: '熱門景點' },
			id: 7,
			info: '為台北市西區最重要且國際化程度最高的消費商圈',
			latitude: '',
			longitude: '',
			order: 0,
			pic: 'https://fakeimg.pl/350x200/?text=osakaShinsaibashi',
			shop: { id: 1, title: 'osakaShinsaibashi' },
			title: 'osakaShinsaibashi',
		},
	],
};



// WEBPACK FOOTER //
// ./src/util/hotel.js